import { render, staticRenderFns } from "./depart-tree-new.vue?vue&type=template&id=018520aa&scoped=true&"
import script from "./depart-tree-new.vue?vue&type=script&lang=js&"
export * from "./depart-tree-new.vue?vue&type=script&lang=js&"
import style0 from "./depart-tree-new.vue?vue&type=style&index=0&id=018520aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018520aa",
  null
  
)

export default component.exports